import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Deadline.scss";
import { useTranslation } from "react-i18next";

function Deadline({ updateDeadline, selectedDeadline }) {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(
    selectedDeadline ? new Date(selectedDeadline) : null,
  );

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (date) {
      // Format date as YYYY-MM-DD in local time (not UTC)
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const formatted = `${year}-${month}-${day}`;
      updateDeadline(formatted);
    }
  };

  const handleClear = () => {
    setSelectedDate(null);
    updateDeadline(null);
  };

  return (
    <div className="deadline-content">
      <h3 className="deadline-headline">{t("tasks.task.deadline")}</h3>
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        inline
        calendarClassName="deadline-calendar"
      />
      <hr className="separator" />
      <div className="clear-button" onClick={handleClear}>
        {t("common.clear")}
      </div>
    </div>
  );
}

export default Deadline;
